/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetFilterModel {
    getFixupPrototypeFunction() { return BudgetFilterModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetFilterModel>): BudgetFilterModel {
        let obj = Object.assign(new BudgetFilterModel(), model);
        BudgetFilterModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetFilterModel>): BudgetFilterModel {
        if (!model) return null;
        return BudgetFilterModel.newInstance(<BudgetFilterModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetFilterModel) {
        if (!obj) return;

        models.BudgetFilterModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetFilterModel): boolean {
        Object.setPrototypeOf(obj, BudgetFilterModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Specify the budget frequency. Example: 'budget frequency':'Daily' Allowed values - Daily,Monthly,Quarterly,Annually
     */
    budget_frequency: string;

    /**
     * Specify the closed period to view the budget amounts for. Allowed values can be obtained from the budget history periods api.
     */
    budget_time_period: string;

}
